<template>
  <div id="boardInfo">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>My Booth</el-breadcrumb-item>
      <el-breadcrumb-item>Raw Space Booth</el-breadcrumb-item>
    </el-breadcrumb>
    <div style='margin:20px 0;font-size:16px;font-weight:bold'>DOWNLOAD</div>
    <div style="padding:0px 0 10px">
      <!-- download -->
      <el-button type="primary"><a :href="file0" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">CAC2025 Exhibitor Manual</a></el-button>
      <el-button type="primary"><a :href="file1" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">Raw Space Exhibitor Instructions</a></el-button>
      <!-- <el-button type="primary"><a :href="file2" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">CAC2024搭建商服务手册</a></el-button>
      <el-button type="primary"><a :href="file3" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">CAC2024 参展展品（国内）运输指南</a></el-button> -->
    </div>
    <div style="margin-top:10px;padding-bottom:100px">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column
          prop="text1"
          width='210'
          label="Important Issue"
         >
        </el-table-column>
        <el-table-column
          prop="text2"
          label="Introduction"
          >
          <template slot-scope="scope">
           <span v-html="scope.row.text2"></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="text3"
          width="190"
          label="Deadline">
          <template slot-scope="scope">
           <span v-html="scope.row.text3"></span>
          </template>
        </el-table-column>
        <el-table-column prop="more" label="More Details" align="center" width="310">
          <template slot-scope="scope">
            <el-button type="primary" style="width:300px" v-if="scope.row.more =='Access Catalogue Entry' || scope.row.more =='Access Exhibitor Badge' " @click="toLink(scope.row.address)">{{scope.row.more}}</el-button>
            <el-button type="primary" style="width:300px" v-else><a :href="scope.row.address" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">{{scope.row.more}}</a></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
import img01 from '@/assets/img01.png'
import img02 from '@/assets/img02.png'
import img03 from '@/assets/img03.png'
export default {
  name: 'boardInfo',
  data () {
    return {
      file0:'./CAC2025 Exhibitor Manual.pdf',
      file1:'./Raw Space Exhibitor Instructions.pdf',
      file2:'./CAC2025 搭建商手册.doc',
      file3:'./CAC2025 参展展品（国内）运输指南.docx',
      tableData:[
        {
          text1:"E-Catalogue Entry & Exhibitor List Entry",
          text2:"The company name you submit for the E-Catalogue will be utilized for the exhibitor list entry.",
          text3:"Exhibitor list <br />February 20, 2025.",
          more:'Access Catalogue Entry',
          type:'',
          address:'/magezine'
        },
        {
          text1:"Exhibitor Badge",
          text2:"Exhibitors are required to make real-name registrations. Please submit your exhibitor badge and identity information, and bring your identity certificate for entry into the hall.",
          text3:"March 16, 2025",
          more:'Access Exhibitor Badge',
          type:'',
          address:'/card'
        },
        {
          text1:"Application for Contractor Registration, Construction Drawing Check, Construction Deposit,Management Fee, Electrical Application",
          text2:"Send email to Official Contractor for relevant services. Application during the exhibition will not be accepted.<br />Cherie Wang: 0086-13472757574   cherie.wang@best-expo.com.cn <br />Sung Ni: 0086-13611912304   sung.ni@best-expo.com.cn ",
          text3:"January 22, 2025",
          more:'View and Download the Document',
          type:'',
          address:'./Application for Contractor.pdf'
        },
        {
          text1:"Insurance ",
          text2:"Refer to the document on the right, contact the insurance service provider to purchase insurance. When submitting the raw space construction plan, an uploaded insurance is required for the approval of the plans and to proceed the onsite construction.Contact:Chen Wenbin, 0086-18930931118",
          text3:"January 22, 2025",
          more:'View and Download the Document',
          type:'',
          address:'./Insurance .pdf'
        },
        {
          text1:"Building Height Approval",
          text2:"According to the regulations of the exhibition hall, indoor single-story over 4.5 meters booths (including 4.5 meters)  and two-story booths should be subject to Building Height Plan Approval.",
          text3:"January 22, 2025",
          more:'View and Download the Document',
          type:'',
          address:'./Building Height and Plan Approval.pdf'
        },
        {
          text1:"Contractor Certicificate",
          text2:"Process your Contractor Certicificate In the NH Hall(2nd floor of the North Hall) with the Construction Deposit.",
          text3:"March 14-16, 2025",
          more:'Access Application Link',
          type:'',
          address:'http://www.neccsh.com/cecsh/watchexhi/applicationflow.jspx'
        },
        {
          text1:"Vehicle Parking Permit and Vehicle Pass Application ",
          text2:"Apply for a Parking Permit (RMB30/Pass/Time) at the Official Forwarder service counter, and collect your Deposit Receipt at Official Contractor service counter in the North Entrance Lobby, and go to the Card Centre in NH Hall (2nd floor of the North Hall) for an Unloading Area Vehicle Pass and an Unloading Area Vehicle Route Guide with Parking Permit and Deposit Receipt.",
          text3:"March 15-16, 2025",
          more:'View and Download the Document',
          type:'',
          address:'./Vehicle Pass for Move-in(Raw Space).pdf'
        },
        {
          text1:"Rental of firefighting three-piece set",
          text2:"According to the requirements of the exhibition hall, raw space exhibitors must rent a firefighting three-piece set to ensure fire safety of their booths during the exhibition period, at the processing locations: Gate 3 of Hall 6.1, Gate 3 of Hall 8.1, Gate 3 of Hall 2.1, and the rental point of the North Hall Security Service Center. ",
          text3:"March 15-16, 2025",
          more:'View and Download the Document',
          type:'',
          address:'./Intelligent Safety Electric Box.pdf'
        }
      ]
    }
  },
  mounted() {
    // this.getsaasfield()
  },
  methods: {
    toLink(str){
      this.$router.replace(str)
      // this.$router.push({ name:str})
      // window.location.href = str
    }
  }
}
</script>
<style lang="less">
#boardInfo{
  font-size:14px;
  @media screen and (max-width:540px){
    .el-form-item__content{
      width: 240px;
    }
    .btns{
      text-align: center;
    }
  }
}
</style>

